import {ReviewItem} from "./reviewitem";

export class ReviewItemMobile extends ReviewItem {
    constructor(data) {
    	data.columns = false;
    	data.infScrollDistance = 300;
    	super(data);

        this.afterCommentRender = this._afterCommentRender.bind(this);
        this.newComment.isSaveButtonVisible.subscribe(this._onCommentAddButtonToggle.bind(this));
	}

	opened = ko.observable(false);

    _afterCommentRender() {
        if(this.opened()) {
            const $panel = $(`#review-list-item-mobile-${this.id}`).find('.dropdown-content');
            this._setCommentsPanelSize($panel);
        }
    }

    _onCommentAddButtonToggle(value) {
        const $panel = $(`#review-list-item-mobile-${this.id}`).find('.dropdown-content');
        const height = $panel.find('.content-inner').innerHeight();
        const buttonHeight = $panel.find('.add-comment-button').outerHeight();
        $panel.css('height', value ? (height + buttonHeight) : (height - buttonHeight));
    }

    _setCommentsPanelSize($content) {
        const height = $content.find('.content-inner').innerHeight();
        $content.css('height', height);
    }

    toggleDetails(item, event) {
        const $toggler = $(event.currentTarget);
        const $content = $toggler.siblings('.dropdown-content');

		if(this.opened()){
            $content.css('height', 0);
        } else{
            this._setCommentsPanelSize($content);
        }

        this.opened(!this.opened());
	}
}



// WEBPACK FOOTER //
// ./modules/reviews/common/model/reviewitemmobile.js